import { get, post, deleteReq, put } from "../../../../common/utils/index.js";
import * as HospitalType from "../../actiontype/HospitalType/Hospital.jsx";
import { getStructuteList } from "../StructureAction.jsx/Structure.jsx";
export const onHospitalReducerUpdate = (payload, reducerType) => {
  return { type: reducerType, payload };
};

export const getPharmacy =
  (headers, showLoader, hideLoader, showToast, dataTrans) => (dispatch) => {
    dispatch({ type: HospitalType.HOSPITAL_PHARMACY_REQUEST });
    showLoader();
    get(`/pharmacies`, headers)
      .then((res) => {
        hideLoader();
        dispatch({
          type: HospitalType.HOSPITAL_PHARMACY_SUCCESS,
          payload: res.data,
        });
        
        if(res?.data?.result?.length === 0){
          // showToast(
          //  "warn",
          // "Attenzione",
          // dataTrans("Nessuna Farmacia Associata trovata")
          // );
        }
      })
      .catch((err) => {
        hideLoader();
        dispatch({
          type: HospitalType.HOSPITAL_PHARMACY_FAILURE,
          payload: err?.message,
        });
        showToast(
          "warn",
          "Attenzione",
          dataTrans(err?.response?.data?.message)
        );
      });
  };
export const getHospitalFacility =
  (showLoader, hideLoader, showToast, dataTrans,facilityHeader) => (dispatch) => {
    dispatch({ type: HospitalType.HOSPITAL_FACILITY_REQUEST });
    showLoader();
    get(`/HospitalFacility`,facilityHeader)
      .then((res) => {        
        hideLoader();
        dispatch({
          type: HospitalType.HOSPITAL_FACILITY_SUCCESS,
          payload: res?.data,
        });
        if(res?.data?.result?.length === 0){
          // showToast(
          //  "warn",
          // "Attenzione",
          // dataTrans("Nessuna Farmacia Associata trovata")
          // );
        }
      })
      .catch((err) => {
        hideLoader();
        dispatch({
          type: HospitalType.HOSPITAL_FACILITY_FAILURE,
          payload: err?.message,
        });
        showToast(
          "warn",
          "Attenzione",
          dataTrans(err?.response?.data?.message)
        );
      });
  };

export const createHospitalFacility =
  (
    payload,
    showLoader,
    hideLoader,
    setIsSuccess,
    showToast,
    dataTrans,
    setIsModalOpen
  ) =>
  (dispatch) => {
    showLoader();
    dispatch({ type: HospitalType.CREATE_HOSPITAL_FACILITY_REQUEST });
    post("/HospitalFacility", payload)
      .then((res) => {
        dispatch({
          type: HospitalType.CREATE_HOSPITAL_FACILITY_SUCCESS,
          payload: res,
        });
        setIsSuccess(true);
        hideLoader();
        var headers = {
          pageNo: 1,
          pageSize: 10,
        };
        dispatch(getStructuteList(headers, showLoader, hideLoader));
        showToast(
          "success",
          dataTrans("text_toast_success"),
          res?.response?.data?.message
        );
      })
      .catch((err) => {
        hideLoader();
        // setIsModalOpen(false)
        dispatch({
          type: HospitalType.CREATE_HOSPITAL_FACILITY_FAILURE,
          payload: err?.response?.data?.message,
        });
        showToast(
          "warn",
          "Attenzione",
          dataTrans(err?.response?.data?.message)
        );
      });
  };

export const getRegion = (year, regionCode ,header) => (dispatch) => {
  //dispatch({ type: HospitalType.REGION_REQUEST_LIST })
  // get(`/Master/AslRegion?year=${year}&regionCode=${regionCode}`)
  dispatch({ type:HospitalType.REGION_ASL_REQUEST_LIST});
  let type =  HospitalType.REGION_SUCCESS_LIST
  if(regionCode && year){
   type =  HospitalType.REGION_ASL_SUCCESS_LIST
  }

  get(`/Master/AslRegion?year=${year}&regionCode=${regionCode}`,header)
    .then((res) => {
      dispatch({ type, payload: res?.data });
    })
    .catch((err) => {
      dispatch({ type ,payload: err?.response?.data?.message, });

    });
};

export const getHospitalPharmacy = (headers) => (dispatch) => {
  get("/pharmacies", headers)
    .then((res) => {
      dispatch({
        type: HospitalType.HOSPITAL_PHARMACY_GET_SUCCESS,
        payload: res?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: HospitalType.HOSPITAL_PHARMACY_GET_FAILURE,
        payload: err?.response?.data?.message,
      });
    });
};

// HospitalFacility
export const getByPharmacyId =
  (id, showLoader, hideLoader, showToast, dataTrans) => (dispatch) => {
    showLoader();
    dispatch({ type: HospitalType.PHARMACY_REQUEST_GETBYID });
    get(`Pharmacy/${id}`)
      .then((res) => {
        dispatch({
          type: HospitalType.PHARMACY_SUCCESS_GETBYID,
          payload: res?.data,
        });
        hideLoader();
        var headers = {
          pageNo: 1,
          pageSize: 10,
          pharmacyType: "hospital",
          isCurrentUser: String(false),
        };
        dispatch(
          getPharmacy(headers, showLoader, hideLoader, showToast, dataTrans)
        );
      })
      .catch((err) => {
        hideLoader();
        dispatch({
          type: HospitalType.PHARMACY_FAILURE_GETBYID,
          payload: err?.response?.data?.message,
        });
        showToast(
          "warn",
          "Attenzione",
          dataTrans(err?.response?.data?.message)
        );
      });
  };

export const deletePharmacy =
  (id, showLoader, hideLoader, showToast, dataTrans) => (dispatch) => {
    showLoader();
    dispatch({ type: HospitalType.PHARMACY_REQUEST_DELETE });
    deleteReq(`Pharmacy/${id}`)
      .then((res) => {
        dispatch({ type: HospitalType.PHARMACY_SUCCESS_DELETE, payload: res });
        hideLoader();
        var headers = {
          pageNo: 1,
          pageSize: 10,
        };
        dispatch(getPharmacy(headers, showLoader, hideLoader));
        showToast(
          "success",
          dataTrans("text_toast_success"),
          res?.response?.data?.message
        );
      })
      .catch((err) => {
        hideLoader();
        dispatch({
          type: HospitalType.PHARMACY_FAILURE_DELETE,
          payload: err?.response?.data?.message,
        });
        showToast(
          "warn",
          "Attenzione",
          dataTrans(err?.response?.data?.message)
        );
      });
  };

export const updatePharmacy =
  (
    id,
    payload,
    headers,
    showLoader,
    hideLoader,
    viewRoleId,
    setIsEditing,
    showToast
  ) =>
  (dispatch) => {
    showLoader();
    dispatch({ type: HospitalType.PHARMACY_REQUEST_UPDATE });
    put(`/Pharmacy/${id}`, payload, headers)
      .then((res) => {
        dispatch({
          type: HospitalType.PHARMACY_SUCCESS_UPDATE,
          payload: res.data,
        });
        hideLoader();
        setIsEditing(false);
        showToast("success", "Attenzione", res?.message);
        dispatch(getByPharmacyId(viewRoleId, showLoader, hideLoader));
      })
      .catch((err) => {
        showToast("warn", "Attenzione", err?.message);
        hideLoader();
        dispatch({
          type: HospitalType.PHARMACY_FAILURE_UPDATE,
          payload: err?.message,
        });
      });
  };

export const createHospitalPharmacy =
  (payload, showLoader, hideLoader, setIsSuccess, showToast, dataTrans) =>
  (dispatch) => {
    showLoader();
    dispatch({ type: HospitalType.PHARMACY_REQUEST_CREATE });
    post("/Pharmacy", payload)
      .then((res) => {
        dispatch({ type: HospitalType.PHARMACY_SUCCESS_CREATE, payload: res });
        setIsSuccess(true);
        hideLoader();
        var headers = {
          pageNo: 1,
          pageSize: 10,
          pharmacyType: "hospital",
          isCurrentUser: String(false),
        };
        dispatch(getPharmacy(headers, showLoader, hideLoader));
        showToast(
          "success",
          dataTrans("text_toast_success"),
          dataTrans(res?.response?.data?.message)
        );
      })
      .catch((err) => {
        hideLoader();
        dispatch({
          type: HospitalType.PHARMACY_FAILURE_CREATE,
          payload: err?.response?.data?.message,
        });
        showToast(
          "warn",
          "Attenzione",
          dataTrans(err?.response?.data?.message)
        );
      });
  };

export const updateStatusPharmacy =
  (id, payload, header, showLoader, hideLoader, showToast, dataTrans) =>
  (dispatch) => {
    showLoader();
    dispatch({ type: HospitalType.PHARMACY_REQUEST_UPDATE });
    put(`/Pharmacy/UpdateStatus/${id}`, payload, header)
      .then((res) => {
        hideLoader();
        dispatch({
          type: HospitalType.PHARMACY_SUCCESS_UPDATE,
          payload: res.data,
        });
        var headers = {
          pageNo: 1,
          pageSize: 10,
          pharmacyType: "hospital",
          isCurrentUser: String(false),
        };
        dispatch(getPharmacy(headers, showLoader, hideLoader));
        showToast(
          "success",
          dataTrans("text_toast_success"),
          res?.response?.data?.message
        );
      })
      .catch((err) => {
        hideLoader();
        dispatch({
          type: HospitalType.PHARMACY_FAILURE_UPDATE,
          payload: err?.message,
        });
        showToast(
          "warn",
          "Attenzione",
          dataTrans(err?.response?.data?.message)
        );
      });
  };
export const getAsl = (addASLObject) => (dispatch) => {
  dispatch({ type: HospitalType.ASL_GET_REQUEST });
  addASLObject.showLoader();
  get(`/Master/Asl`,addASLObject.headersAsl)
    .then((res) => {
      addASLObject.hideLoader();
      dispatch({ type: HospitalType.ASL_GET_SUCCESS, payload: res.data });
      // addASLObject.showToast('success',addASLObject.dataTrans('text_toast_success'),addASLObject.dataTrans(res?.response?.data?.message));
    })
    .catch((err) => {
      addASLObject.hideLoader();
      dispatch({ type: HospitalType.ASL_GET_FAILURE, payload: err?.message });
      addASLObject.showToast(
        "warn",
        "Attenzione",
        addASLObject?.t(err?.response?.data?.message)
      );
    });
};


export const getAslCheck = (payload,showLoader, hideLoader, showToast, dataTrans,setSuccess,handleRemain) => (dispatch) => {
  showLoader()
  post(`/HospitalFacility/checkASLExists`,payload)
    .then((res) => {
      if(res.message === "SUCCESS"){
        hideLoader()
        setSuccess(true)
        handleRemain()
      }
    })
    .catch((err) => {
      setSuccess(false)
      showToast(
        "warn",'Esiste già',
        dataTrans(err?.response?.data?.message)
      );
      hideLoader()
    });
};
